<template>
  <div class="layout">
    <div class="header flex">
      <img class="logo" src="@/assets/images/logo.png">

      <div
        class="mobile-menu-icon"
        :class="{active: isMenuShow}"
        @click="handleMenuToggle"
      >
        <span class="menu-icon" />
      </div>

      <ul v-show="isMenuShow" class="menu flex">
        <li
          v-for="(menu, index) in menus"
          :key="index"
          :class="{active: currentPath == menu.url}"
          @click="handleMenu(menu)"
        >{{ menu.name }}</li>
      </ul>
    </div>
    <router-view />
  </div>
</template>

<script>
import { os } from '@/utils/index'
const { isPc } = os()

export default {
  data() {
    return {
      isMenuShow: !!isPc,
      currentPath: '',
      menus: [
        {
          name: '官网',
          url: 'https://dev.robloxdev.cn/'
        },
        {
          name: '我的创作',
          url: 'https://create.robloxdev.cn/creations'
        },
        {
          name: '精彩活动',
          url: 'https://robloxdev.cn/events/'
        },
        {
          name: '开发教程',
          url: 'https://developer.roblox.com/zh-cn/'
        },
        {
          name: '编程课程',
          url: 'https://education.roblox.com/zh-cn/'
        },
        {
          name: '开发者论坛',
          url: 'https://forum.robloxdev.cn'
        },
        {
          name: '视频中心',
          url: 'https://space.bilibili.com/402416759?from=search&seid=17513191545287343929'
        }
      ]
    }
  },
  mounted() {
    const currentPath = this.$route.name

    this.currentPath = currentPath

    const ths = this

    document.addEventListener('mouseup', function (e) {
      e.stopPropagation()

      ths.isMenuShow = !!isPc
    })
  },
  methods: {
    handleMenuToggle() {
      this.isMenuShow = !this.isMenuShow
    },
    handleMenu(item) {
      if (item.url.indexOf('http') > -1) {
        window.open(item.url)
      } else {
        this.currentPath = item.url
        this.$router.push({
          name: item.url
        })
      }
      this.isMenuShow = !!isPc
    }
  }
}
</script>

<style>

.m-logo {
  display: none;
}

.foot_dark .foot_cpright{
  margin: 0 auto;
  padding-left: 0;
  padding-right: 0;
  width: 1200PX;

}
.foot_dark .foot_ieg_logo {
  background-image: url("../assets/images/tencentlogoop.png") !important;
  background-repeat: no-repeat !important;
  width: 398PX !important;
}

@media screen and (max-width: 800px) {
  .m-logo {
    display: block;
    font-size: 0;
    background: #252525;
    padding: .5rem 0 0 0;
  }
  .m-logo>img {
    display: block;
    width: 3.81rem;
    height: .3rem;
    margin: 0 auto;
  }
  .foot,
  .afooter {
    font-size: .22rem;
    text-align: center;
    padding: .5rem 0;
    background: #252525;
  }
}
</style>

<style lang="scss" scoped>
.layout{
  position: relative;

  .logo{
    margin-right: 26PX;
  }

  .header {
    position: absolute;
    top: 20PX;
    left: 0;
    padding: 0 60PX;
    opacity: 0.83;
    width: 100%;
    text-align: left;
  }

  .menu {
    position: relative;
    flex-grow: 1;
    li {
			position: relative;
      padding: 0 26PX;
      font-size: 16PX;
      color: #FFFFFF;
      line-height: 41PX;
      cursor: pointer;
      letter-spacing: 2px;

      // &:last-of-type {
      //   position: absolute;
      //   top: 0;
      //   right: 0;
      // }

			&.active:after,
			&:hover:after {
				content: "";
				position: absolute;
				display: block;
				top: 80%;
				left: 26PX;
				right: 26PX;
				height: 2px;
				background-color: rgba(255,255,255,1);
			}
    }
  }

  .mobile-menu-icon {
    display: none;
  }
}

@media screen and (max-width: 800px) {
  .layout {
    .header {
      position: relative;
      height: 116px;
      top: 0;
      padding: 36px;
      background-color: #131313;
    }

    .logo {
      height: 80%;
    }

    .menu {
      position: absolute;
      top: 116px;
      right: 0;
      padding: 20px 0;
      width: 180px;
      background-color: #000;

      li {
        padding: 0 30px;
        width: 100%;
        height: 60px;
				line-height: 60px;
        font-size: 24px;

        &:last-of-type {
          position: static;
        }

				&.active:after,
				&:hover:after {
					display: none;
				}
      }
    }

    .mobile-menu-icon {
      display: block;
      position: absolute;
      top: 40px;
      right: 36px;
      width: 40px;
      height: 40px;

      &.active {
        .menu-icon {
          background-color: transparent;

          &:after {
            top: 0;
            transform: rotate(45deg);
          }
          &:before {
            bottom: 0;
            transform: rotate(-45deg);
          }
        }
      }

      .menu-icon {
        display: block;
        position: absolute;
        top: 15px;

        width: 100%;
        height: 2PX;
        background-color: #fff;

        &:after,
        &:before {
          content: "";
          position: absolute;
          left: 0;
          width: 100%;
          height: 2PX;
          background-color: #fff;
          transition: all 300ms;
        }

        &:after {
          top: -15px;
        }
        &:before {
          bottom: -13px;
        }
      }
    }
  }
}
</style>
